import { styled } from "@mui/system";
import { TextField, Button, Box, Paper, Checkbox, FormControlLabel } from "@mui/material";

// Modern TextField component with labels above input fields
export const ModernTextField = styled(TextField)(({ theme }) => ({
  marginBottom: "24px", // space-y-6 equivalent
  "& .MuiOutlinedInput-root": {
    borderRadius: "6px",
    backgroundColor: "#FFFFFF",
    border: "1px solid #D1D5DB",
    transition: "all 0.2s ease-in-out",
    position: "relative",
    "&:hover": {
      borderColor: "#9CA3AF",
    },
    "&.Mui-focused": {
      borderColor: "#0073A6",
      boxShadow: "0 0 0 3px rgba(0, 115, 166, 0.1)",
    },
    "&.MuiInputBase-root": {
      backgroundColor: "#FFFFFF",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
  },
  "& .MuiInputLabel-root": {
    color: "#374151",
    fontSize: "14px",
    fontWeight: 500,
    fontFamily: "Inter, Inter Fallback, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important",
    position: "static",
    transform: "none",
    marginBottom: "8px",
    display: "block",
    "&.Mui-focused": {
      color: "#0073A6",
    },
  },
  "& .MuiInputBase-input": {
    fontSize: "14px",
    padding: "12px 12px 12px 40px", // pl-10 equivalent for icon
    color: "#1F2937",
    fontFamily: "Inter, Inter Fallback, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important",
    backgroundColor: "#FFFFFF !important",
    "&::placeholder": {
      color: "#9CA3AF",
      opacity: 1,
    },
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 1000px white inset",
      WebkitTextFillColor: "#1F2937",
    },
    "&:-webkit-autofill:hover": {
      WebkitBoxShadow: "0 0 0 1000px white inset",
    },
    "&:-webkit-autofill:focus": {
      WebkitBoxShadow: "0 0 0 1000px white inset",
    },
  },
  "& .MuiInputAdornment-root": {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#9CA3AF",
    pointerEvents: "none",
  },
  "& .MuiInputAdornment-positionStart": {
    left: "12px",
  },
  "& .MuiInputAdornment-positionEnd": {
    right: "20px",
    pointerEvents: "auto",
  },
}));

// Modern Button component
export const ModernButton = styled(Button)(({ theme }) => ({
  borderRadius: "25px",
  padding: "12px 16px",
  fontSize: "14px",
  fontWeight: 500,
  textTransform: "none",
  fontFamily: "Inter, Inter Fallback, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important",
  boxShadow: "none",
  transition: "all 0.2s ease-in-out",
  width: "100%",
  "&:hover": {
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
  },
  "&:focus": {
    boxShadow: "0 0 0 2px rgba(0, 115, 166, 0.2)",
  },
}));

// Gradient Background component
export const GradientBackground = styled(Box)(({ theme }) => ({
  minHeight: "100vh",
  background: "linear-gradient(180deg, #3b6793 0%, #010910 100%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "24px",
  position: "relative",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "radial-gradient(circle at 20% 80%, rgba(0, 196, 240, 0.1) 0%, transparent 50%), radial-gradient(circle at 80% 20%, rgba(0, 115, 166, 0.1) 0%, transparent 50%)",
    pointerEvents: "none",
  },
}));

// Auth Card component
export const AuthCard = styled(Paper)(({ theme }) => ({
  borderRadius: "20px",
  padding: "40px",
  maxWidth: "420px",
  width: "100%",
  boxShadow: "0 20px 40px rgba(18, 36, 60, 0.08)",
  border: "1px solid rgba(255, 255, 255, 0.8)",
  backdropFilter: "blur(20px)",
  backgroundColor: "rgba(255, 255, 255, 0.95)",
  position: "relative",
  zIndex: 1,
}));

// Modern Checkbox component
export const ModernCheckbox = styled(Checkbox)(({ theme }) => ({
  color: "#9CA3AF",
  "&.Mui-checked": {
    color: "#0073A6",
  },
  "&:hover": {
    backgroundColor: "rgba(0, 115, 166, 0.04)",
  },
}));

// Modern FormControlLabel component
export const ModernFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  "& .MuiFormControlLabel-label": {
    fontSize: "14px",
    fontWeight: 500,
    color: "#374151",
    fontFamily: "Inter, Inter Fallback, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif !important",
  },
}));